import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  studentProjectQuery,
  studentServiceAsAction,
  examRegistrationStudent,
  getStudentAdditionalInfoQuery,
  studentFilesQuery,
  continuumBasicDetailsQuery,
  studentOffenceListQuery,
  getGainContinuumQuery,
  ibPYPElementRatingsGenericQuery,
  getStudentProjectGroupIdsQuery,
  getGainContinuumRemarkQuery,
  getStudentPortfolioDownloadInfoQuery,
  getStudentBillingInfoQuery,
  getStudentPortfolioDownloadJobCountForUserQuery,
  getStudentAcademicYearsQuery,
  getStudentBehaviourSummaryQuery,
  getOrganizationConstantsQuery,
  getStudentAlertTypesQuery,
} from "./ProfileDetailsQueries";
import {
  getOrganizationGlobalConstantsQuery,
  getOrganizationAcademicYearsQuery,
} from "modules/CommonQuery";
import { studentFamilyInfo } from "StudentProfileCommon/modules/StudentProfileQuery";
import {
  studentAlertFragment,
  studentInfofragment,
} from "./ProfileDetailsFragments";

export const getOrganizationConstantsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationConstantsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentBehaviourSummaryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentBehaviourSummaryQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeStudentBehaviourSummariesToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getStudentBehaviourSummaryQuery,
      variables,
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const getStudentFamiliesInfoFromCache = ({ studentId, filters }) => {
  try {
    const queryData = client.readQuery({
      query: studentFamilyInfo,
      variables: {
        id: studentId,
        filters,
      },
    });

    return queryData ? _.get(queryData, "node", {}) : {};
  } catch (e) {
    return {};
  }
};

export const getStudentProjectGroupIdsFromCache = ({
  id,
  projectGroupFilters,
}) => {
  try {
    const queryData = client.readQuery({
      query: getStudentProjectGroupIdsQuery,
      variables: {
        id,
        projectGroupFilters,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentProjectQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: studentProjectQuery,
      variables,
    });

    return queryData ? _.get(queryData, "node", {}) : {};
  } catch (e) {
    return {};
  }
};

export const writeStudentFamiliesInfoToCache = ({
  studentId,
  data,
  filters,
}) => {
  try {
    client.writeQuery({
      query: studentFamilyInfo,
      variables: {
        id: studentId,
        filters,
      },
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getStudentServiceAsActionFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: studentServiceAsAction,
      variables,
    });

    return queryData ? queryData : {};
  } catch (e) {
    return {};
  }
};

export const getExamRegistrationStudentFromCache = ({ id }) => {
  try {
    const queryData = client.readQuery({
      query: examRegistrationStudent,
      variables: {
        id,
      },
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
export const getStudentAdditionalInfoFromCache = ({ studentId }) => {
  try {
    const queryData = client.readQuery({
      query: getStudentAdditionalInfoQuery,
      variables: {
        studentId,
      },
    });
    return queryData ? queryData : {};
  } catch (e) {
    return {};
  }
};

export const writeStudentProfileExamDetailIntoCache = ({ id, data }) => {
  try {
    client.writeQuery({
      query: examRegistrationStudent,
      variables: { id },
      data: { node: data },
    });
  } catch (e) {
    return {};
  }
};

export const getStudentFilesFromCache = variables => {
  try {
    const result = client.readQuery({
      query: studentFilesQuery,
      variables,
    });
    return _.get(result, "node", {});
  } catch (e) {
    return {};
  }
};

export const continuumBasicDetailsFromCache = variables => {
  try {
    const result = client.readQuery({
      query: continuumBasicDetailsQuery,
      variables,
    });
    return _.get(result, "node", {});
  } catch (e) {
    return {};
  }
};

export const organizationGlobalConstantFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getOrganizationGlobalConstantsQuery,
      variables,
    });
    return _.get(result, "node", {});
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const studentOffenceListFromCache = variables => {
  try {
    const result = client.readQuery({
      query: studentOffenceListQuery,
      variables,
    });
    return _.get(result, "node", {});
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const getOrganizationAcademicYearsFromCache = ({
  organizationId,
  currentCurriculumProgramId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationAcademicYearsQuery,
      variables: {
        id: organizationId,
        filters: {
          curriculumProgramIds: [currentCurriculumProgramId],
        },
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getGainContinuumFromCache = ({ studentId, continuumId }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGainContinuumQuery,
      variables: {
        id: studentId,
        filters: {
          continuumIds: [continuumId],
        },
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeGainContinuumToCache = ({ studentId, continuumId, data }) => {
  let queryData = {};
  try {
    queryData = client.writeQuery({
      query: getGainContinuumQuery,
      variables: {
        id: studentId,
        filters: {
          continuumIds: [continuumId],
        },
      },
      data: { node: data },
    });
  } catch (e) {}
};

export const ibPYPElementRatingsGenericFromCache = ({
  id,
  dataSet,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: ibPYPElementRatingsGenericQuery,
      variables: {
        id: id,
        dataSet: dataSet,
        filters: filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getStudentCoursesFromCache = ({ studentId, courseFilters }) => {
  try {
    const queryData = client.readFragment({
      id: `Student:${studentId}`,
      fragment: studentInfofragment.studentCourses,
      fragmentName: "studentCoursesItem",
      variables: {
        courseFilters,
      },
    });
    return queryData || {};
  } catch (e) {
    return {};
  }
};

export const gainContinuumRemarkFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getGainContinuumRemarkQuery,
      variables,
    });
    return _.get(result, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentPortfolioDownloadInfoFromCache = ({ id, filters }) => {
  try {
    const queryData = client.readQuery({
      query: getStudentPortfolioDownloadInfoQuery,
      variables: {
        id: id,
        filters: filters,
      },
    });
    return queryData;
  } catch (e) {
    return {};
  }
};

export const getStudentBillingInfoFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentBillingInfoQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentPortfolioDownloadJobCountForUserFromCache = ({
  id,
  filters,
}) => {
  try {
    const queryData = client.readQuery({
      query: getStudentPortfolioDownloadJobCountForUserQuery,
      variables: {
        id: id,
        filters: filters,
      },
    });
    return queryData;
  } catch (e) {
    return {};
  }
};

export const getStudentAcademicYearsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentAcademicYearsQuery,
      variables,
    });
    return _.get(queryData, "node", []);
  } catch (e) {
    return {};
  }
};

export const getStudentAlertTypesFromCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getStudentAlertTypesQuery,
      variables,
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentAlertFromCache = ({ id }) => {
  try {
    const queryData = client.readFragment({
      id: `StudentAlert:${id}`,
      fragment: studentAlertFragment,
      fragmentName: "studentAlertFields",
    });

    return queryData ?? {};
  } catch (e) {
    return {};
  }
};

//TODO: Add support for pagination
